export default function PHP_enddeclare() {
  return (
    <div>
      <h1>PHP_enddeclare</h1>
    </div>
  );
}
